import { render, staticRenderFns } from "./VSpinnerIconLoader.vue?vue&type=template&id=a7d65e94&scoped=true"
import script from "./VSpinnerIconLoader.vue?vue&type=script&lang=js"
export * from "./VSpinnerIconLoader.vue?vue&type=script&lang=js"
import style0 from "./VSpinnerIconLoader.vue?vue&type=style&index=0&id=a7d65e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d65e94",
  null
  
)

export default component.exports